import { makeStyles } from "tss-react/mui"
import { MenuItem, TextField } from "@mui/material"
import { CreateRoomResourceForm, RoomDetailsColor } from "../../../resourcesTypes"
import { StandardForm } from "../../../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../../../shared/components/forms/StandardMainPanel"
import { LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"
import {
    FormikAutoComplete,
    FormikDropdown,
    FormikSwitch,
    FormikTextField,
} from "../../../../../../../../shared/components/forms/Formik"
import { StandardSidePanel } from "../../../../../../../../shared/components/forms/StandardSidePanel"
import { useFormikContext } from "formik"

const useStyles = makeStyles()(() => ({
    roomNumberInput: {
        width: "50%",
    },
    percentageInput: {
        width: "7.5rem",
    },
}))

export function FormCarGeneralContent() {
    const { classes } = useStyles()
    const { values } = useFormikContext<CreateRoomResourceForm>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict
                    id="resources-create-car-tab-general-registration-number-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField name="carDetails.registrationNumber" label="Registration number" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-car-tab-general-name-label" attrs={{ label: true }}>
                    <FormikTextField name="name" label="Name" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-car-tab-general-description-label" attrs={{ label: true }}>
                    <FormikTextField rows={4} multiline name="description" label="Description" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-car-tab-general-parking-location-label" attrs={{ label: true }}>
                    <FormikTextField name="carDetails.parkingLocation" label="Standard parking location" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-car-tab-general-location-of-keys-label" attrs={{ label: true }}>
                    <FormikTextField name="carDetails.keysLocation" label="Location of keys" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-room-tab-general-tags-label" attrs={{ label: true }}>
                    <FormikAutoComplete
                        name="tags"
                        label="Tags"
                        freeSolo
                        multiple
                        options={values.tags ?? []}
                        fullWidth
                        renderInput={() => <TextField />}
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="resources-create-car-tab-general-side-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="resources-create-car-tab-general-active-label">
                        <FormikSwitch<CreateRoomResourceForm> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
